import { useCallback, useRef } from "react"

import { useGetScanHistoryStatistics } from "@/api/useScanHistory"
import { Table } from "@/atoms"
import { useNumberConvertor } from "@/hooks/useNumberConvertor"
import { NumberCell } from "@/molecules/NumberCell"
import { getTopInitiatorsByPolicyNameSelector } from "@/pages/GovernancePage/applications/scan-history/useScanHistory.selector"
import { Initiator } from "./Initiator"

import styles from "../HeaderScanHistoryTab.module.scss"

import type { ScanHistoryStatisticsResponse } from "@/api/useScanHistory.types"
import type { TableTopInitiatorWidgetProps } from "./TopInitiatorWidget.types"

export const TopInitiatorsTable = ({
  filters
}: TableTopInitiatorWidgetProps) => {
  const select = useCallback(
    (response: ScanHistoryStatisticsResponse) =>
      getTopInitiatorsByPolicyNameSelector(response, filters),
    [filters]
  )
  const { response, isLoading } = useGetScanHistoryStatistics(undefined, {
    select
  })
  const { data } = response || {}
  const convertors = useNumberConvertor()
  const columns = useRef([
    {
      title: null,
      dataIndex: "initiator",
      render: Initiator
    },
    {
      title: null,
      dataIndex: "count",
      width: 75,
      align: "right" as const,
      render: NumberCell(convertors)
    }
  ]).current

  return (
    <Table
      className={styles.topInitiatorsTable}
      showHeader={false}
      pagination={false}
      loading={isLoading}
      dataSource={data}
      columns={columns}
    />
  )
}
